import {useTranslation} from '@aboutyou/i18n';
import {Flyout, Text} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {Captcha} from './Captcha';

interface CaptchaFlyoutProps {
  onSuccess: (code: string) => void;
  isOpen: boolean;
  onClose: VoidFunction;
  renderInPortal?: boolean;
  captchaUniqueKey: string;
}

export const CaptchaFlyout = (props: CaptchaFlyoutProps) => {
  const {isOpen, onClose, onSuccess, renderInPortal} = props;
  const {t} = useTranslation();
  return (
    <Flyout
      renderInPortal={!!renderInPortal}
      open={isOpen}
      data-testid="captchaFlyout"
      onClose={onClose}
      headerContent={
        <Text size="px18">{t("Checking that you're not a robot. 🤖")}</Text>
      }
      bodyContent={
        <Container>
          <Captcha onSuccess={onSuccess} uniqueKey={props.captchaUniqueKey} />
        </Container>
      }
    />
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
`;
